<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

<div
  class="scroll page-bg flex-fill overflow-auto pt-3 pt-lg-8 pb-3 px-5 centerform"
>
  <div class="container p-0">
    <form [formGroup]="studentForm">
      <div class="mControls">
        <div class="input-group mr-auto">
          <h1 class="m-0 text-white align-items-center d-inline-flex">
            {{
              editStudent
                ? "Update " +
                  studentToEdit?.first_name +
                  " " +
                  (studentToEdit?.second_name
                    ? studentToEdit?.second_name + " "
                    : "") +
                  studentToEdit?.last_name
                : "Create New Student"
            }}
          </h1>
        </div>
        <div class="mControls__right">
          <div class="input-group">
            <button mat-raised-button (click)="_location.back()">Cancel</button>
          </div>
          <div class="input-group">
            <button
              mat-raised-button
              (click)="updateStudent(studentForm.value)"
              color="primary"
              [disabled]="!studentForm.valid"
            >
              {{ editStudent ? "Update" : "Done" }}
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-7 mb-3">
          <div class="card">
            <div class="card-header">General</div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>First Name</mat-label>
                    <input
                      maxlength="25"
                      placeholder="First Name"
                      matInput
                      name="firstName"
                      id="firstName"
                      type="text"
                      formControlName="first_name"
                      required
                    />
                    <mat-error
                      *ngIf="studentForm.get('first_name').hasError('required')"
                      >First Name is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Middle Name</mat-label>
                    <input
                      maxlength="25"
                      placeholder="Middle Name"
                      matInput
                      name="secondName"
                      id="secondName"
                      type="text"
                      formControlName="second_name"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Last Name</mat-label>
                    <input
                      maxlength="25"
                      placeholder="Last Name"
                      matInput
                      name="lastName"
                      id="lastName"
                      type="text"
                      formControlName="last_name"
                      required
                    />
                    <mat-error
                      *ngIf="studentForm.get('last_name').hasError('required')"
                      >Last Name is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Teacher</mat-label>
                    <input
                      maxlength="50"
                      placeholder="Teacher"
                      matInput
                      name="teacher"
                      id="teacher"
                      type="text"
                      formControlName="class_name"
                      required
                    />
                    <mat-error
                      *ngIf="studentForm.get('class_name').hasError('required')"
                      >Teacher is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>School name</mat-label>
                    <mat-select formControlName="school" required>
                      <mat-option>
                        <ngx-mat-select-search
                          style="width: 100%"
                          [formControl]="schoolControl"
                          [noEntriesFoundLabel]="'No matching School found'"
                          placeholderLabel="Search School"
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option
                        *ngFor="let school of schoolOptions"
                        [value]="school.id"
                      >
                        {{ school.school_name }}
                        {{ school.uuid ? "(" + school.uuid + ")" : "" }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="studentForm.get('school').hasError('required')"
                      >School is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Grade</mat-label>
                    <mat-select
                      formControlName="grade"
                      (selectionChange)="isControlCheck()"
                      required
                    >
                      <mat-option
                        *ngFor="let grade of grades"
                        [value]="grade.id"
                      >
                        {{ grade.grade_level }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="studentForm.get('grade').hasError('required')"
                      >Grade is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Zone</mat-label>
                    <mat-select
                      formControlName="zone"
                      (selectionChange)="isControlCheck()"
                    >
                      <mat-option
                        *ngFor="let zone of zones"
                        [value]="zone.id"
                      >
                        {{ zone.zone }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>1st Grade School Years</mat-label>
                    <input
                      [mask]="textMask"
                      maxlength="25"
                      placeholder="ex. 2016/2017"
                      matInput
                      name="fifthGrade"
                      id="fifthGrade"
                      type="text"
                      formControlName="fifth_grade_year"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>2nd Grade School Years</mat-label>
                    <input
                      [mask]="textMask"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 47"
                      maxlength="25"
                      placeholder="ex. 2016/2017"
                      matInput
                      name="secondGrade"
                      id="secondGrade"
                      type="text"
                      formControlName="second_grade_year"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>3rd Grade School Years</mat-label>
                    <input
                      [mask]="textMask"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 47"
                      maxlength="25"
                      placeholder="ex. 2016/2017"
                      matInput
                      name="thirdGrade"
                      id="thirdGrade"
                      type="text"
                      formControlName="third_grade_year"
                    />
                  </mat-form-field>
                </div>

                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label style="color: #aeb1b4">Pairing Number</mat-label>
                    <mat-select>
                      <mat-option
                        *ngFor="let pair of pairingGroups"
                        [value]="pair.value"
                      >
                        {{ pair.display }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Skill Level</mat-label>
                    <mat-select formControlName="preference" required>
                      <mat-option
                        *ngFor="let brand of preferences"
                        [value]="brand.id"
                      >
                        {{ brand.preference_color_name | titlecase }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="studentForm.get('preference').hasError('required')"
                      >Skill Level is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Placement Result</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="placement_result"
                    name="placement_result"
                    id="placement_result"
                    (keydown)="allowOnlyNumbers($event)"
                  />
                  <!-- Explain the accepted placement format directly in the form. -->
                  <mat-error *ngIf="studentForm.get('placement_result').hasError('min')">
                    Placement result must be 11 or greater and end in 1.
                  </mat-error>

                  <mat-error *ngIf="studentForm.get('placement_result').hasError('max')">
                    Placement result cannot be greater than 999.
                  </mat-error>
                  <mat-error *ngIf="studentForm.get('placement_result').hasError('pattern') && !studentForm.get('placement_result').hasError('min')"
>
                    Placement result must end in 1, such as 11, 21, or 211.
                  </mat-error>
                </mat-form-field>
              </div>
                <div class="col-lg-6" *ngIf="this.studentId > 0">
                  <div
                    *ngIf="
                      this.studentToEdit?.grade.grade_level === '5th' ||
                      this.studentToEdit?.grade.grade_level === '4th'
                    "
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Reading Level</mat-label>
                      <mat-select formControlName="is_reading_level">
                        <mat-option
                          *ngFor="let item of readingLevel"
                          [value]="item.value"
                        >
                          {{ item.display }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12">
                  <mat-form-field
                    class="w-100 no-error"
                    appearance="outline"
                    class="w-100"
                  >
                    <mat-label *ngIf="!studentId">Other Information</mat-label>
                    <textarea
                      formControlName="other_information"
                      name="other_information"
                      id="other_information"
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="8"
                      cdkAutosizeMaxRows="8"
                      placeholder="Other Information"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-5">
          <div class="card">
            <div class="card-header">Program Information</div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <mat-label><strong>Category</strong></mat-label
                  ><br />
                  <mat-checkbox
                    formControlName="control_group"
                    name="control_group"
                    >Control Group</mat-checkbox
                  >
                </div>
                <div class="col-lg-6" *ngIf="editStudent">
                  <mat-label><strong>Associated Tutors</strong></mat-label>
                  <br />
                  <mat-label *ngIf="tutorList.length" style="margin-bottom: 5em"
                    >Primary Tutor</mat-label
                  >
                  <div *ngFor="let tutor of tutorList">
                    <div *ngIf="tutor.LeadTutor === 1">
                      <ul>
                        <li>
                          {{ tutor?.UserName ? tutor?.UserName : "Nil" }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <mat-label *ngIf="tutorList.length"
                    >Secondary Tutor(s)</mat-label
                  >
                  <br />
                  <div *ngFor="let tutor of tutorList">
                    <div *ngIf="tutor.LeadTutor === 0">
                      <ul>
                        <li>
                          {{ tutor?.UserName ? tutor?.UserName : "Nil" }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div *ngIf="tutorList?.length == 0">
                    <em>No tutors associated</em>
                  </div>
                </div>
                <div class="col-12 mt-4">
                  <mat-form-field
                    class="w-100 no-error"
                    appearance="outline"
                    class="w-100"
                  >
                    <mat-label *ngIf="!studentId">Notes</mat-label>
                    <textarea
                      formControlName="notes"
                      placeholder="Notes"
                      name="notes"
                      id="notes"
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="4"
                      cdkAutosizeMaxRows="8"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
  <div class="card-header">Student Files</div>
  <div class="card-body">
    <!-- Display the list of current files if available -->
    <div *ngIf="studentToEdit?.files?.length > 0" class="mb-2">
      <p *ngFor="let file of studentToEdit.files; let i = index" class="list-files">
        <a [href]="file.file_url" target="_blank">{{getFileNameFromUrl(file.file_url)}}</a>
         <span>
          <!-- Cross icon to delete the file -->
          <mat-icon 
            title="Delete" 
            style="cursor: pointer; color: red;" 
            (click)="deleteConsentForm(file.id)"
          >
            close
          </mat-icon>
        </span>
      </p>
    </div>

    <!-- File input for adding or changing the file -->
    <input
      type="file"
      (change)="onFileChange($event)"
      accept=".pdf"
    />

    <!-- Warning message -->
    <p *ngIf="fileError" class="text-danger">{{ fileError }}</p>
  </div>
</div>


        </div>
      </div>
    </form>
  </div>
</div>


